import * as React from "react";
import { Measurement } from "../../../../../../Measurement/modules/SecondaryProductInfo/FrameMeasurements/components/Measurement/Measurement.js";
const MeasurementList = ({ measurements }) => {
  return /* @__PURE__ */ React.createElement("ul", { className: "product-detail-frame-measurements__items" }, measurements.map((item) => /* @__PURE__ */ React.createElement(Measurement, { ...item, key: item.key, isListItem: true })));
};
export {
  MeasurementList
};
//# sourceMappingURL=MeasurementList.js.map
